import { FC } from 'react';
import { Tooltip } from 'react-tooltip';
import { useTranslate } from 'hooks/useTranslate';
import { SocietyEquityMarketStatus } from 'types/Society';

export const incentivesMarketStatusConfig: Record<
  SocietyEquityMarketStatus,
  { icon: string; badge: string; labelKey: string; tooltipKey: string }
> = {
  OPEN: {
    icon: 'ni-check-circle',
    badge: 'badge-info',
    labelKey: 'MarketStatusOpen',
    tooltipKey: 'MarketStatusOpenTooltip',
  },
  CLOSED: {
    icon: 'ni-na',
    badge: 'badge-warning',
    labelKey: 'MarketStatusClosed',
    tooltipKey: 'MarketStatusClosedTooltip',
  },
  UNAVAILABLE: {
    icon: 'ni-cross-circle',
    badge: 'badge-danger',
    labelKey: 'MarketStatusUnavailable',
    tooltipKey: 'MarketStatusUnavailableTooltip',
  },
};

type IncentivesMarketStatusBadgeProps = {
  status: SocietyEquityMarketStatus;
  hideTooltip?: boolean;
};

const IncentivesMarketStatusBadge: FC<IncentivesMarketStatusBadgeProps> = ({
  status,
  hideTooltip = false,
}) => {
  const { t } = useTranslate();
  const config = incentivesMarketStatusConfig[status];

  return hideTooltip ? (
    <span className={`badge ${config.badge}`}>
      <em className={`icon ni ${config.icon} mr-1`} />
      {t(config.labelKey)}
    </span>
  ) : (
    <>
      <span
        className={`badge ${config.badge} cursor-help`}
        data-tooltip-id={`${config.labelKey}-tooltip`}
      >
        <em className={`icon ni ${config.icon} mr-1`} />
        {t(config.labelKey)}
      </span>

      <Tooltip
        id={`${config.labelKey}-tooltip`}
        place="top"
        style={{ zIndex: 9999 }}
        className="w-max-300px "
      >
        {t(config.tooltipKey)}
      </Tooltip>
    </>
  );
};

export default IncentivesMarketStatusBadge;
